// QuickBooks service constants and configuration

export const IMPORT_SETTINGS = {
  DEFAULT_BATCH_SIZE: 500,
  BATCH_DELAY_MS: 100
};

export const ERROR_MESSAGES = {
  AUTH_REQUIRED: 'Authentication required',
  USER_NOT_AUTHENTICATED: 'User not authenticated',
  QB_CONNECTION_EXPIRED: 'QuickBooks connection has expired. Please reconnect to QuickBooks.',
  QB_NO_CONNECTION: 'No QuickBooks connection found. Please connect to QuickBooks first.',
  QB_CUSTOMERS_FETCH_FAILED: 'Failed to fetch customers from QuickBooks. Please try again.',
  QB_TOKEN_REFRESH_FAILED: 'Failed to refresh token',
  QB_OAUTH_INVALID: 'Invalid response from QuickBooks OAuth',
  QB_PDF_NOT_FOUND: 'Invoice PDF not found in QuickBooks',
  QB_PDF_CONNECTION_EXPIRED: 'QuickBooks connection has expired. Please reconnect.'
};

export const HTTP_STATUS = {
  NOT_FOUND: 404,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403
};